import React from 'react';
const EmailSVG = ({ isBlack = true }) => {
    return (React.createElement("svg", { width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5 7H19.5V7.00004L19.5 7ZM18.6397 7H6.3602L12.5 11.3855L18.6397 7ZM5.5 7.61447V17H19.5V7.61443L12.5 12.6145L5.5 7.61447ZM4.5 6H5.5H19.5H20.5V7V17V18H19.5H5.5H4.5V17V7V6Z", fill: isBlack ? 'black' : '#0000008c' })));
};
export default EmailSVG;
